import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { ActiveModel } from '../active-model';
import { Model } from '../model';
import { ModelDiameterRange } from '../model-diameter-range';
import { AdapterBuilder } from './adapter.builder';
import { BrandBuilder } from './brand.builder';
import { ControlBuilder } from './control.builder';
import { MachineGroupBuilder } from './machine-group.builder';
import { MachineGroupSectionBuilder } from './machine-group-section.builder';
import { TheoreticalMachineBuilder } from './theoretical-machine.builder';
import { VibrationPowerModeBuilder } from './vibration-power-mode.builder';

export class ModelBuilder {
  static fromJson(json) {
    return (json)
      ? new Model(
        json.hash,
        json.name,
        parseNumber(json.order),
        json.imagePath,
        json.active,
        parseNumber(json.defaultTaskDeviation),
        parseNumber(json.reference),
        json.ip,
        json.ftpUser,
        json.ftpPassword,
        json.serverPath,
        json.logPath,
        json.alarmPath,
        json.programPath,
        parseNumber(json.cycle),
        ControlBuilder.fromJson(json.control),
        BrandBuilder.fromJson(json.brand),
        AdapterBuilder.fromJson(json.adapter),
        parseNumber(json.correctionFactor),
        parseNumber(json.defaultToolTime),
        parseNumber(json.defaultPieceTime),
        parseNumber(json.timeCorrector),
        VibrationPowerModeBuilder.fromJson(json.vibrationPowerMode),
        json.readMode,
        MachineGroupBuilder.fromJson(json.workingModelGroup),
        parseNumber(json.numberOfPaths),
        parseNumber(json.partsCounterPath),
        parseNumber(json.programReadLimit),
        json.continuousProductionVariable,
        parseNumber(json.continuousProductionVariablePath),
        json.continuousProductionVariableReversed,
        parseNumber(json.pauseMinTime),
        parseNumber(json.subprogramCodeLimitToSend),
        json.allowsWriting,
        json.feederType,
        parseNumber(json.maxPartLengthMm),
        json.supportsRearEjection,
        ModelBuilder.diameterRangesFromList(json.diameterRanges),
        MachineGroupSectionBuilder.fromJson(json.section),
        TheoreticalMachineBuilder.fromList(json.theoreticalMachines)
      )
      : null;
  }

  static diameterRangesFromList(list): ModelDiameterRange[] {
    if (!Array.isArray(list)) {
      return [];
    }
    return list
      .filter(item => !!item)
      .map(item => new ModelDiameterRange(
        item.hash,
        item.label,
        parseNumber(item.minDiameterMm),
        parseNumber(item.maxDiameterMm)
      ));
  }

  static fromList(list) {
    return mapCollection(ModelBuilder.fromJson, list);
  }

  static activeModelFromJson(json) {
    return (json)
      ? new ActiveModel(
        json.hash,
        json.name,
        parseNumber(json.reference),
        parseNumber(json.order),
        json.imagePath,
        json.active,
        json.brandImage,
        json.brandBWImage,
        parseNumber(json.defaultTaskDeviation),
        json.vibration,
        AdapterBuilder.fromJson(json.adapter),
        parseNumber(json.defaultToolTime),
        parseNumber(json.defaultPieceTime),
        parseNumber(json.timeCorrector),
        json.readMode,
        MachineGroupBuilder.fromJson(json.workingModelGroup),
        json.allowsWriting
      )
      : null;
  }

  static activeModelsFromList(list) {
    return mapCollection(ModelBuilder.activeModelFromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/model.builder.ts